/* eslint-disable no-empty-label */
import router from './../../router'
import { getToken } from '../../utils/auth'
import ApiUser from './../../apis/user'
import { Message as $message } from 'element-ui'

export default {
  state: {
    token: getToken(),
    roles: [],
    name: '',
    avatar: '',
    userNo: '',
    //服务商的几个字段
    orgId: '',
    orgName: '',
    providerId: '',
    providerLogo: '',
    providerName: '',

    userRole: '', //用户身份

    //外包商的几个字段
    outsourceId: '',
    outsourceName: '',
    outsourceType: 1 //1:企业外包商、2:个人外包商
  },

  getters: {
    token: (state) => state.token,
    roles: (state) => state.roles,
    avatar: (state) => state.avatar,
    username: (state) => state.name,
    //很奇怪？ orgId可能Wie空  然后这两个值是一样的
    orgId: (state) => state.orgId,
    userNo: (state) => state.userNo,
    outsourceId: (state) => state.outsourceId,
    outsourceName: (state) => state.outsourceName,
    isPersonnelOutsource: (state) => state.outsourceType === 2,
    userRole: (state) => state.userRole //这个是用户身份  provider  outsource
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USER_ROLE: (state, userRole) => {
      state.userRole = userRole
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_USER_NO: (state, userNo) => {
      state.userNo = userNo
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_ORG_ID: (state, orgId) => {
      state.orgId = orgId || ''
    },
    SET_ORG_NAME: (state, orgName) => {
      state.orgName = orgName
    },
    SET_PROVIDER_ID: (state, providerId) => {
      state.providerId = providerId
    },
    SET_PROVIDER_NAME: (state, providerName) => {
      state.providerName = providerName
    },
    SET_PROVIDER_LOGO: (state, providerLogo) => {
      state.providerLogo = providerLogo
    },
    SET_OUTSOURCE_NAME: (state, outsourceName) => {
      state.outsourceName = outsourceName
    },
    SET_OUTSOURCE_ID: (state, outsourceId) => {
      state.outsourceId = outsourceId
    },
    SET_OUTSOURCE_TYPE: (state, outsourceType) => {
      state.outsourceType = outsourceType
    }
  },
  actions: {
    LogBackByToken: function (store, token) {
      store.getters.storage.setItem('token', token)
      store.commit('SET_TOKEN', token)
    },
    InitUserRole: function ({ commit }, roles) {
      commit('SET_ROLES', roles)
    },
    RequireUserInfo: function ({ commit }) {
      return new Promise((resolve, reject) => {
        ApiUser.userInfo()
          .then((res) => {
            commit('SET_NAME', res.name)
            commit('SET_AVATAR', res.avatar)
            commit('SET_USER_NO', res.userNo)
            const service = res.serviceLoginResponse
            let outsource = res.outsourcerResponse
            if (Array.isArray(outsource)) {
              outsource = outsource[0]
            }
            if (service) {
              commit('SET_ORG_ID', service.orgId || '')
              commit('SET_ORG_NAME', service.orgName || '')
              commit('SET_PROVIDER_ID', service.providerId || '')
              commit('SET_PROVIDER_NAME', service.providerName || '')
              commit('SET_PROVIDER_LOGO', service.providerLogo || '')
              commit('SET_USER_ROLE', 'provider')
              resolve({ ...res, type: 'provider' })
            } else if (outsource) {
              //如果是外包商
              commit('SET_OUTSOURCE_NAME', outsource.name || '')
              commit('SET_OUTSOURCE_ID', outsource.id || '')
              commit('SET_OUTSOURCE_TYPE', outsource.type || '')
              commit('SET_USER_ROLE', 'outsource')
              resolve({ ...res, type: 'outsource' })
            } else {
              $message.error({
                message: '用户信息为空',
                duration: 1000,
                onClose() {
                  reject(res)
                }
              })
            }
          })
          .catch((err) => {
            err.errMsg && $message.error(err.errMsg)
            reject(err)
          })
      })
    },

    /**
     * @2019/4/18
     * @author: huiming
     * desc:  初始化的时候调用，因为我们有的时候如刷新页面并不可能需要重新登录，
     * 从缓存中读出数据，然后相当于直接登录成功（判断数据有效）
     */
    InvalidToken: function (store) {
      //token过期 清除用户信息进入 login
      store.commit('SET_TOKEN', '')
      store.getters.storage.removeItem('token')
      //清除 tag的缓存
      store.dispatch('emptyTags')
      //避免其他几个有权限的页面导致的 reload不到登录页
      sessionStorage.clear()
      localStorage.clear()
      //end
      history.replaceState({}, null, '/#/login')
      location.reload()
    },

    ReplaceLogin: function (store) {
      store.commit('SET_TOKEN', '')
      store.getters.storage.removeItem('token')
      //清除 tag的缓存
      store.dispatch('emptyTags')
      //跳转到登录页面
      router.replace('/login')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js